<div class="container-right-main fluid-container">
  <div class="adminfeedback">
    <div class="top-row">
      <div class="left-titl-buton">
        <div class="title">
          Feedback
        </div>
        <div id="loader" class="loader"></div>
      </div>
    </div>

    <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
      <mat-tab label="All Feedback" *ngIf="canViewAllFeedbackTab">
        <div class="display-flex filter-container">
          <div class="float-left">
            <app-search-field [formControl]="searchFilter" placeholder="Search by user name or user request"
              [showMatchCount]="true" [matchCount]="totalCount">
            </app-search-field>
          </div>
          <div class="float-right">
            <app-select [formControl]="feedbackTypeFilter" [field]="{ label: 'Feedback Type', options: [
                       { label: 'All', value: '' },
                       { label: 'Positive', value: 'Positive' },
                       { label: 'Negative', value: 'Negative' }
                     ] }">
            </app-select>
          </div>
        </div>

        <app-grid [data]="filteredFeedbackList" [columns]="feedbackColumns" [config]="gridConfig"
          (rowClick)="onRowClick($event)" (cellClick)="onAssigneeCellClick($event)">
        </app-grid>
        <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="currentPage"
          [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)" showFirstLastButtons>
        </mat-paginator>
      </mat-tab>

      <mat-tab label="My Feedback" *ngIf="canViewMyFeedbackTab">
        <div class="display-flex filter-container">
          <div class="float-left">
            <app-search-field [formControl]="searchFilter" placeholder="Search by user name or user request"
              [showMatchCount]="true" [matchCount]="totalCount">
            </app-search-field>
          </div>
          <div class="float-right">
            <app-select [formControl]="feedbackTypeFilter" [field]="{ label: 'Feedback Type', options: [
                       { label: 'All', value: '' },
                       { label: 'Positive', value: 'Positive' },
                       { label: 'Negative', value: 'Negative' }
                     ] }">
            </app-select>
          </div>
        </div>

        <app-grid [data]="filteredFeedbackList" [columns]="feedbackColumns" [config]="gridConfig"
          (rowClick)="onRowClick($event)" (cellClick)="onAssigneeCellClick($event)">
        </app-grid>
        <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="currentPage"
          [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)" showFirstLastButtons>
        </mat-paginator>
      </mat-tab>

      <mat-tab label="Assigned Feedback" *ngIf="canViewAssignedFeedbackTab">
        <div class="display-flex filter-container">
          <div class="float-left">
            <app-search-field [formControl]="searchFilter" placeholder="Search by user name or user request"
              [showMatchCount]="true" [matchCount]="totalCount">
            </app-search-field>
          </div>
          <div class="float-right">
            <app-select [formControl]="feedbackTypeFilter" [field]="{ label: 'Feedback Type', options: [
                       { label: 'All', value: '' },
                       { label: 'Positive', value: 'Positive' },
                       { label: 'Negative', value: 'Negative' }
                     ] }">
            </app-select>
          </div>
        </div>

        <app-grid [data]="filteredFeedbackList" [columns]="feedbackColumns" [config]="gridConfig"
          (rowClick)="onRowClick($event)" (cellClick)="onAssigneeCellClick($event)">
        </app-grid>
        <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="currentPage"
          [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)" showFirstLastButtons>
        </mat-paginator>
      </mat-tab>

      <mat-tab label="Open Feedback" *ngIf="canViewOpenFeedbackTab">
        <div class="filter-search" style="display: flex; align-items: center; gap: 16px;">
          <app-search-field [formControl]="searchFilter" placeholder="Search by user name or user request"
            [showMatchCount]="true" [matchCount]="totalCount">
          </app-search-field>
          <app-select [formControl]="feedbackTypeFilter" [field]="{ label: 'Feedback Type', options: [
                       { label: 'All', value: '' },
                       { label: 'Positive', value: 'Positive' },
                       { label: 'Negative', value: 'Negative' }
                     ] }" style="width: 220px; margin-left: auto;">
          </app-select>
        </div>
        <app-grid [data]="filteredFeedbackList" [columns]="feedbackColumns" [config]="gridConfig"
          (rowClick)="onRowClick($event)" (cellClick)="onAssigneeCellClick($event)">
        </app-grid>
        <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageIndex]="currentPage"
          [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)" showFirstLastButtons>
        </mat-paginator>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>